import { Card } from './Card'
import { Icon, type IconName } from './Icon'
import { arrow, fmtPct } from '../lib/money'

interface Props {
  icon: IconName
  tone: 'mint' | 'royal' | 'honey' | 'sky2' | 'flame' | 'plum' | 'ink'
  label: string
  value: string
  delta?: number
  sub?: string
  className?: string
}

const toneMap: Record<Props['tone'], { bg: string; text: string }> = {
  mint:  { bg: 'bg-mint-50',  text: 'text-mint-600'  },
  royal: { bg: 'bg-royal-50', text: 'text-royal-600' },
  honey: { bg: 'bg-honey-50', text: 'text-honey-600' },
  sky2:  { bg: 'bg-sky2-50',  text: 'text-sky2-600'  },
  flame: { bg: 'bg-flame-50', text: 'text-flame-600' },
  plum:  { bg: 'bg-plum-50',  text: 'text-plum-600'  },
  ink:   { bg: 'bg-ink-100',  text: 'text-ink-700'   },
}

export function KpiCard({ icon, tone, label, value, delta, sub, className = '' }: Props) {
  const t = toneMap[tone]
  return (
    <Card className={`p-5 ${className}`}>
      <div className="flex items-center justify-between">
        <div className={`w-9 h-9 rounded-lg grid place-items-center ${t.bg}`}>
          <Icon name={icon} className={`w-5 h-5 ${t.text}`} />
        </div>
        {delta !== undefined && (
          <span className={`pill ${delta >= 0 ? 'pill-mint' : 'pill-flame'}`}>
            {arrow(delta)} {fmtPct(delta)}
          </span>
        )}
      </div>
      <div className="mt-3 text-[12px] font-semibold text-ink-500 uppercase tracking-wider">{label}</div>
      <div className="mt-1 num font-bold text-[28px] leading-tight">{value}</div>
      {sub && <div className="mt-1 text-[12px] text-ink-500">{sub}</div>}
    </Card>
  )
}
